import React from 'react';
// import { Grid } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material'; // Import Box for the root element
import { useTheme } from '@mui/material/styles';
import sealdhsfooterUrl from '../images/seal-dhs-footer.png';

function Footer() {
  const theme = useTheme();
  // Define styles directly as objects to be used with the sx prop
  const ecmirFooterSx = {
    backgroundImage: "url(" + sealdhsfooterUrl + ")",
    backgroundColor: '#1c3764',
    backgroundRepeat: "no-repeat",    
    backgroundPositionX: 'center',
    backgroundPositionY: '15px',    
    padding: '10px 0 0 0',
    [theme.breakpoints.down('sm')]: {            
      height: '96px',
      // paddingLeft: '16px',
    }, // No default height specified for larger screens, so it will adapt
  };

  const containerSx = {
    width: '100%',
    display: 'flex',
    height: '86px',    
  };

  const linkscontainerSx = {
    width: '100%',
    backgroundColor: '#1c3764',
    display: 'flex',
    height: '110px',
    // paddingTop: '10px',
    paddingBottom: '10px',
    [theme.breakpoints.down('sm')]: {            
      flexDirection: 'column', // Changed from 'inline-table' to 'column' for flex container
      height: '186px',
      flexWrap: 'wrap', // Allow items to wrap in column direction if needed
    },
    // These were props on the Grid, now moved to sx for consistency
    alignItems: 'flex-start',
    justifyContent: 'space-around',
  };

  const cbpTextSx = {
    color: 'white',
    fontFamily: 'Open Sans, Helvetica Neue, Tahoma, Arial, sans-serif',
    fontSize: '15.3px',    
    marginBottom: '1px',
    // paddingRight: '120px',    
  };

  const linkSx = {
    color: '#fff',
	  fontWeight: '700',
	  textDecoration: 'none',
    backgroundColor: 'transparent',
    alignSelf: 'center'
  };

  const paperworkreductionSx = {
      fontSize: '0.85em',
      background: '#142949',
      paddingTop: '4px',
      color: '#fff',
      padding: '0.5px 50px 0.5px 50px'
  };

  return (    
    <Box sx={{ flexGrow: 1 }}> {/* Replaces the 'root' style */}
      <Grid sx={ecmirFooterSx}>
        <Grid sx={containerSx}></Grid>
        <Grid container sx={linkscontainerSx}>
        <Grid sx={cbpTextSx}>
        
        <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
          <Box component="a" sx={linkSx} href="https://www.dhs.gov" title="Department of Homeland Security" target="_blank" rel="noopener noreferrer">
            DHS.gov         
          </Box>
          <Box component="a" sx={linkSx} href="https://www.cbp.gov/site-policy-notices/accessibility" title="Accessibility" target="_blank" rel="noopener noreferrer">
            Accessibility          
          </Box>
          </Grid>
        </Grid>
        <Grid sx={cbpTextSx}>
          <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
          <Box component="a" sx={linkSx} href="https://www.cbp.gov" title="Customs and Border Protection" target="_blank" rel="noopener noreferrer">
              CBP.gov         
            </Box>
            <Box component="a" sx={linkSx} href="https://www.cbp.gov/newsroom/publications/performance-accountability-financial" title="Accountabillity" target="_blank" rel="noopener noreferrer">
              Accountabillity
            </Box>
          </Grid>                
        </Grid>

        <Grid sx={cbpTextSx}>
          <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
          <Box component="a" sx={linkSx} href="https://www.cbp.gov/about" title="About CBP" target="_blank" rel="noopener noreferrer">
              About CBP         
            </Box>
            <Box component="a" sx={linkSx} href="https://www.cbp.gov/site-policy-notices/privacy-policy" title="Privacy Policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy         
            </Box>
          </Grid>                
        </Grid>

        <Grid sx={cbpTextSx}>
          <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
          <Box component="a" sx={linkSx} href="https://www.cbp.gov/contact" title="Contact CBP" target="_blank" rel="noopener noreferrer">
            Contact CBP         
          </Box>
          <Box component="a" sx={linkSx} href="https://www.cbp.gov/site-policy-notices/foia" title="FOIA" target="_blank" rel="noopener noreferrer">
              FOIA        
            </Box>
          </Grid>
        </Grid>

        <Grid sx={cbpTextSx}>
          <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
            <Box component="a" sx={linkSx} href="https://www.oig.dhs.gov/" title="Inspector General" target="_blank" rel="noopener noreferrer">
              Inspector General         
            </Box>
            <Box component="a" sx={linkSx} href="https://www.cbp.gov/about/eeo-diversity/no-fear-act" title="No Fear Act" target="_blank" rel="noopener noreferrer">
             No Fear Act        
            </Box>
          </Grid>
        </Grid>

        <Grid sx={cbpTextSx}>
          <Grid container sx={{ ...containerSx, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' }}>
            <Box component="a" sx={linkSx} href="/" title="Home" target="_blank" rel="noopener noreferrer">
              Home         
            </Box>
            <Box component="a" sx={linkSx} href="https://www.cbp.gov/document/directives/vulnerability-disclosure-program-policy-and-rules-engagement" title="Vulnerability Disclosure" target="_blank" rel="noopener noreferrer">
          Vulnerability Disclosure          
          </Box>
          </Grid>
        </Grid>
      </Grid>

      <Grid container sx={{ ...containerSx, alignItems: 'center', justifyContent: 'space-evenly' }}>
        <Grid sx={paperworkreductionSx}>
          <p>
          Paperwork Reduction Act: An agency may not conduct or sponsor an information collection and a person is not required to 
          respond to this information unless it displays a current valid OMB control number. The control number for this 
          collection is 1506-0014. The estimated average time to complete this application is 11 minutes. If you have any 
          comments regarding the burden estimate you can write to U.S. Customs and Border Protection, Office of Regulations 
          and Rulings, 90 K Street, NE, Washington DC 20229.
          </p>
        </Grid>
      </Grid>
    </Grid>
    </Box>
  );
}

export default Footer;
